import { EditOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Tooltip, Typography } from "antd";
import useEditableCell from "hooks/useEditableCell";
import { formatCurrency, formatPercentage } from "utils";

const useColumns = (precioId, setPreciosSeguros, setHasUnsavedChanges, setOpenEditar) => {
  const defaultColumns = [
    {
      title: "Artículo",
      dataIndex: "descripcion",
    },
    {
      title: "Seguro",
      dataIndex: "seguro",
      width: 100,
      align: "right",
      inputWidth: "100%",
      editable: true,
      render: (value) => formatPercentage(value),
    },
    {
      title: "VD mín.",
      dataIndex: "seguro_minimo",
      width: 100,
      align: "right",
      inputWidth: "100%",
      editable: true,
      render: (value) => formatCurrency(value),
    },
    {
      title: (
        <Button
          size="small"
          type="primary"
          icon={<EditOutlined />}
          onClick={() => setOpenEditar(true)}
        >
          Editar
        </Button>
      ),
      children: [
        {
          title: "VD máx. sin autorización",
          dataIndex: "seguro_maximo",
          width: 100,
          align: "right",
          inputWidth: "100%",
          editable: true,
          render: (value) => formatCurrency(value),
        },
        {
          title: (
            <>
              <Typography.Text>VD sin docum.</Typography.Text>
              {" "}
              <Tooltip title="Valor declarado asegurado máximo sin declaración fiscal respaldatoria.">
                <QuestionCircleOutlined />
              </Tooltip>
            </>
          ),
          dataIndex: "seguro_sin_documentacion",
          width: 100,
          align: "right",
          inputWidth: "100%",
          editable: true,
          render: (value) => formatCurrency(value),
        },
      ]
    }
  ];
  
  const handleEdit = (record, campo, nuevoValor) => {
    setPreciosSeguros(prev =>
      prev.map(p =>
        p.id === precioId ? {
          ...p,
          seguros: p.seguros.map(item =>
            item.id === record.id ? { 
              ...item, 
              [campo]: nuevoValor,
              editado: true  // marca solo este registro
            } : item
          )
        } : p
      )
    );

    setHasUnsavedChanges(prev => ({
      ...prev,
      [precioId]: true,
    }));
  };

  const { components, columns } = useEditableCell(defaultColumns, handleEdit);

  return {
    columns,
    components,
  }
}

export default useColumns;